/* eslint no-undef: "off" */

jQuery(function($){ 
  $('.fm-loadmore').click(function() {

    let params = fm_loadmore_params
    let btn = $(this)
    let data = {
      'action': 'loadmore',
      'query': params.posts,
      'page': params.current_page,
    }

    $.ajax({
      url: params.ajaxurl,
      data: data,
      type: 'POST',
      beforeSend: function() {
        btn.text('Loading...')
      },
      success: function(data) {
        if (data) {
          btn.text('Load More Posts')


          // Adds the posts the bottom of the content element
          $('.fm-loadmore-content').append(data)
          params.current_page++;

          if (params.current_page == params.max_page) {
            // This could be a disabled state
            btn.remove()
          }
        } else {
          // Possibly swap for a message that all posts are loaded by swaping elements
          btn.remove()
        }
      },
    })
  })
})